<template>
  <div id="container">
    <div class="location">
      <ul>
        <li class="home">홈</li>
        <li>자료실</li>
        <li>주요서식 다운로드</li>
      </ul>
    </div>

    <div class="pageTit">
      <div class="conWrap">
        <h2>주요서식 다운로드</h2>
      </div>
    </div>

    <div class="contents">
      <div class="conWrap">
        <h3 class="conTit">주요서식 다운로드</h3>
        <div class="tabStyle2">
          <table>
            <caption>
              주요서식 다운로드
            </caption>
            <colgroup>
              <col width="*" />
              <col width="140" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col" height="62" class="tal pdl60">제목</th>
                <th scope="col" class="tal pdl20">자료</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td height="74" class="tal pdl60">
                  1. 적하홈페이지 청약방법 안내
                </td>
                <td class="tal">
                  <button
                    @click="down('contract.pdf')"
                    class="btnDown btnPdf"
                    target="_blank"
                    title="새창"
                  >
                    <span class="hide"
                      >적하홈페이지 청약방법 안내 PDF 다운</span
                    >
                  </button>
                </td>
              </tr>
              <tr>
                <td height="74" class="tal pdl60">2. 적하홈페이지 이용소개</td>
                <td class="tal">
                  <button
                    @click="down('instructions.pdf')"
                    class="btnDown btnPdf"
                    target="_blank"
                    title="새창"
                  >
                    <span class="hide">적하홈페이지 이용소개 PDF 다운</span>
                  </button>
                </td>
              </tr>
              <tr>
                <td height="74" class="tal pdl60">3. 계약취소 사유서</td>
                <td class="tal">
                  <button
                    @click="down('d_cncl.doc')"
                    class="btnDown btnDoc"
                    target="_blank"
                    title="새창"
                  >
                    <span class="hide">계약취소 사유서 DOC 다운</span>
                  </button>
                </td>
              </tr>
              <tr>
                <td height="74" class="tal pdl60">4. 무사고확인증</td>
                <td class="tal">
                  <button
                    @click="down('d_no_accdnt.doc')"
                    class="btnDown btnDoc"
                    target="_blank"
                    title="새창"
                  >
                    <span class="hide">무사고확인증 DOC 다운</span>
                  </button>
                </td>
              </tr>
              <tr>
                <td height="74" class="tal pdl60">5. 적하 보험 청약서</td>
                <td class="tal">
                  <button
                    @click="down('d_crg.doc')"
                    class="btnDown btnDoc"
                    target="_blank"
                    title="새창"
                  >
                    <span class="hide">적하 보험 청약서 DOC 다운</span>
                  </button>
                </td>
              </tr>
              <tr>
                <td height="74" class="tal pdl60">
                  6. 개인 신용 정보 동의서 및 운송 보험 청약서
                </td>
                <td class="tal">
                  <button
                    @click="down('d_agree.hwp')"
                    class="btnDown btnHwp"
                    target="_blank"
                    title="새창"
                  >
                    <span class="hide"
                      >개인 신용 정보 동의서 및 운송 보험 청약서 HWP 다운</span
                    ></button
                  ><button @click="down('p_agree.pdf')" class="btnDown btnPdf">
                    <span class="hide"
                      >개인 신용 정보 동의서 및 운송 보험 청약서 PDF 다운</span
                    ></button
                  ><button
                    @click="down('d_trns.xls')"
                    class="btnDown btnXls"
                    target="_blank"
                    title="새창"
                  >
                    <span class="hide"
                      >개인 신용 정보 동의서 및 운송 보험 청약서 XLS 다운</span
                    ></button
                  ><button @click="down('d_trns.pdf')" class="btnDown btnPdf">
                    <span class="hide"
                      >개인 신용 정보 동의서 및 운송 보험 청약서 PDF 다운</span
                    >
                  </button>
                </td>
              </tr>
              <tr>
                <td height="74" class="tal pdl60">7. 보험금 지급 동의서</td>
                <td class="tal">
                  <button
                    @click="down('d_insu.doc')"
                    class="btnDown btnDoc"
                    target="_blank"
                    title="새창"
                  >
                    <span class="hide">보험금 지급 동의서 DOC 다운</span>
                  </button>
                </td>
              </tr>
              <tr>
                <td height="74" class="tal pdl60">
                  8. Letter of Assignment (위임장)
                </td>
                <td class="tal">
                  <button
                    @click="down('d_lttr.doc')"
                    class="btnDown btnDoc"
                    target="_blank"
                    title="새창"
                  >
                    <span class="hide"
                      >Letter of Assignment (위임장) DOC 다운</span
                    >
                  </button>
                </td>
              </tr>
              <tr>
                <td height="74" class="tal pdl60">
                  9. Subrogation Form (대위권 양도증)
                </td>
                <td class="tal">
                  <button
                    @click="down('d_sub.doc')"
                    class="btnDown btnDoc"
                    target="_blank"
                    title="새창"
                  >
                    <span class="hide"
                      >Subrogation Form (대위권 양도증) DOC 다운</span
                    >
                  </button>
                </td>
              </tr>
              <tr>
                <td height="74" class="tal pdl60">10. 사전 손해사정 확인서</td>
                <td class="tal">
                  <button
                    @click="down('d_damage.doc')"
                    class="btnDown btnDoc"
                    target="_blank"
                    title="새창"
                  >
                    <span class="hide">사전 손해사정 확인서 DOC 다운</span>
                  </button>
                </td>
              </tr>
              <tr>
                <td height="74" class="tal pdl60">
                  11. 적하보험 인터넷 계 약 약정서
                </td>
                <td class="tal">
                  <button
                    @click="down('d_crgin.doc')"
                    class="btnDown btnDoc"
                    target="_blank"
                    title="새창"
                  >
                    <span class="hide"
                      >적하보험 인터넷 계약 약정서 DOC 다운</span
                    ></button
                  ><button @click="down('p_crgin.pdf')" class="btnDown btnPdf">
                    <span class="hide"
                      >적하보험 인터넷 계약 약정서 PDF 다운</span
                    >
                  </button>
                </td>
              </tr>
              <tr>
                <td height="74" class="tal pdl60">
                  12. 인터넷 적하보험 사용 신청서
                </td>
                <td class="tal">
                  <button
                    @click="down('d_incrg.doc')"
                    class="btnDown btnDoc"
                    target="_blank"
                    title="새창"
                  >
                    <span class="hide"
                      >인터넷 적하보험 사용 신청서 DOC 다운</span
                    ></button
                  ><button @click="down('p_incrg.pdf')" class="btnDown btnPdf">
                    <span class="hide"
                      >인터넷 적하보험 사용 신청서 PDF 다운</span
                    >
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// @ is an alias to /src

import { ref, reactive, inject, onMounted, onBeforeUpdate } from "vue";
const axios = inject("axios");
import encDownload from "@/common/encDownload";

async function down(file) {
  const encFilePath = await encDownload.encryptData(
    "/attach/sea/ozd/pdf/cargo/",
    true
  );
  const encFileName = await encDownload.encryptData(file, true);

  return axios.download(
    "/downloadEnc.do?addFilePath=" + encFilePath + "&addFileNm=" + encFileName
  );

  // return axios.download("/download.do?addFilePath=/attach/sea/ozd/pdf/cargo/&addFileNm=" + file);
}
</script>
